@if (options$ | async; as options) {
  @if (schema$ | async; as schema) {
    <mat-form-field
      [appearance]="options?.appearance"
      attr.data-test="schema-form-widget-input-{{ path() }}"
      class="h-full w-full min-h-full min-w-full"
    >
      @if (options?.showLabel !== false) {
        <mat-label>
          <smallstack-form-field-title [path]="path()"></smallstack-form-field-title>
        </mat-label>
      }
      @if (prefixIcon) {
        <smallstack-icon [name]="prefixIcon" size="24" matPrefix></smallstack-icon>
      }
      <input
        matInput
        [matAutocomplete]="auto"
        [required]="required"
        [ngModel]="value$ | async"
        (ngModelChange)="setValue($event); validateOnChange()"
        (blur)="validateOnBlur()"
        [errorStateMatcher]="errorStateMatcher"
        [placeholder]="placeholder"
        data-test="schema-form-widget-input"
      />
      <mat-autocomplete #auto="matAutocomplete">
        @for (option of filteredOptions | async; track option) {
          <mat-option [value]="option">
            {{ option }}
          </mat-option>
        }
      </mat-autocomplete>
      @if (schema.description && options?.showHint !== false && options?.useInfoBox !== true) {
        <mat-hint>{{ schema.description }}</mat-hint>
      }
      <mat-error data-test="validation-error-text" class="justify-end">{{ validationErrorText() }} </mat-error>
      @if (schema.description && options?.showHint !== false && options?.useInfoBox === true) {
        <div matSuffix>
          <smallstack-icon
            name="question-mark"
            theme="ios-glyphs"
            color="AAAAAA"
            size="16"
            [matTooltip]="schema.description"
            style="cursor: help; padding-bottom: 4px"
          ></smallstack-icon>
        </div>
      }
    </mat-form-field>
  }
}
